export default "__VITE_ASSET__DTQ_VYSH__"